import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ScheduleCourse } from './course_builder';
import { ScheduleLocation } from './location_builder';
import { ScheduleSectionLabels } from './schedule_labels_builder';
import { ScheduleSection } from './schedule_section_builder';
import { ScheduleTerm } from './schedule_terms_builder';
import { ScheduleSectionTime } from './section_time_builder';

export class Schedule implements IIndexable {
  id: string;
  section: ScheduleSection[];
  term: ScheduleTerm[];
  section_time: ScheduleSectionTime[];
  location: ScheduleLocation;
  course: ScheduleCourse;
  section_status: any[];
  section_labels: ScheduleSectionLabels[];

  constructor(schedule: Partial<Schedule>) {
    _4.forEach(
      schedule.section_time as ScheduleSectionTime[],
      (section_time: any) => (section_time = new ScheduleSectionTime(section_time))
    );
    _4.forEach(
      schedule.section_labels as ScheduleSectionLabels[],
      (section_labels: any) => (section_labels = new ScheduleSectionLabels(section_labels))
    );
    _4.merge(this, schedule);
  }

  static build(schedule: Partial<Schedule>): Schedule {
    return new Schedule(schedule);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/builders/schedule_builder.ts